
export function generateEnumTranslations<T>(enumObject: T, prefix: string): Record<number, string> {
  return Object.fromEntries(
    Object.values(enumObject)
      .filter(value => typeof value === 'number')
      .map(value => [value, `${prefix}.${enumObject[value].charAt(0).toLowerCase()}${enumObject[value].slice(1)}`])
  );
}